import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- TASK TYPES
// ---------------------------------

const ENDPOINT_BILLING_CUSTOMERS = '/billing-customers';

const logger = LoggerService.getInstance();

/**
 * Requete le endpoint billing-customers GET
 * Récupère la liste des donneurs d'ordre
 * @param param0
 */
const get = async ({accessToken,page}:I_ACCESS_TOKEN_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - billing_customers - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_BILLING_CUSTOMERS}${APP_CONFIG.ENDPOINT_SUFFIX}${page ? '?page=' + page : ''}`;
  return _customFetch(URL,options);
};

interface I_BILLING_CUSTOMER_POST_PARAMS {
  accessToken: string,
  name: string,
}
/**
 * Requete le endpoint billing-customers POST
 * Crée un donneur d'ordre
 * @param param0
 * @returns
 */
const post = async ({accessToken,name}:I_BILLING_CUSTOMER_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - billing_customers - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
    })
  };
  const URL = ENDPOINT_BILLING_CUSTOMERS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint billing-customers DELETE
 * Supprime un donneur d'ordre
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - billing_customers - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_BILLING_CUSTOMERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_BILLING_CUSTOMER_PUT_PARAMS {
  accessToken: string,
  id: number,
  name: string,
}
/**
 * Requete le endpoint billing-customers PUT
 * Modifie un donneur d'ordre
 * @param param0
 * @returns
 */
const put = async ({accessToken,id,name}:I_BILLING_CUSTOMER_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - billing_customers - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
    })
  };
  const URL = `${ENDPOINT_BILLING_CUSTOMERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};


interface I_BILLING_CUSTOMERS_IMPORT_PARAMS {
  accessToken: string,
  file: File,
}
/**
 * Requete le endpoint billing customers POST file
 * Importe des doneurs d'ordre
 * @param param0
 * @returns
 */
const importList = async ({accessToken,file}:I_BILLING_CUSTOMERS_IMPORT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - billing_customers - importList...'));
  const formData  = new FormData();
  formData.append("file",file,file.name);
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      // 'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: formData,
  };
  const URL = `${ENDPOINT_BILLING_CUSTOMERS}/import${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const billingCustomersEndpoints = {
  get,
  post,
  remove,
  put,
  importList,
};

export default billingCustomersEndpoints;
